import { jsx as _jsx } from "react/jsx-runtime";
import jsonnetApi from '../api/jsonnetApi';
import JsonnetContext from '../contexts/Jsonnet.context';
import { useWidgetContext } from '../index';
export const JsonnetConfigProvider = {
    hooks: () => {
        const { configuration: { dimensions }, } = useWidgetContext();
        return dimensions;
    },
    initialize: (dimensions) => {
        return jsonnetApi
            .getConfiguration(dimensions || {})
            .then((config) => {
            return { config: config };
        });
    },
    component: ({ children, config }) => {
        return (_jsx(JsonnetContext.Provider, { value: config, children: children }, void 0));
    },
};
//# sourceMappingURL=JsonnetConfig.provider.js.map